module.exports = __webpack_public_path__ + "static/media/design.bbd142e1.svg";